import React from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Text } from 'apps/auth/components/common/Text/Text';
import ActivityAmount from 'apps/auth/components/ga/activity/components/ActivityAmount';
import ActivityIcon from 'apps/auth/components/ga/activity/components/ActivityIcon';
import ActivityStatus from 'apps/auth/components/ga/activity/components/ActivityStatus';
import ActivityTitle from 'apps/auth/components/ga/activity/components/ActivityTitle';
import { STATUS_OK } from 'apps/auth/constants/Constants';
import { getGaActivityDate } from 'apps/auth/helpers/utils';

const ActivityFasterPaymentDetails = (props) => {
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { textColor, titleColor } = props.options;

    const getStatusText = () => {
        let statusText = props.chequeStatusInProgress;
        if (item.mobileInfo.stsId < STATUS_OK && item.fromchequeBankAccountStatusBean) {
            statusText = props.chequeAccountStatusInProgress;
            // <c:set var="cssClassStatus" value="sending"/>
        } else if (item.mobileInfo.stsId < STATUS_OK && item.waitingVerification) {
            statusText = props.chequeStatusWaitingVerification;
        } else if (item.mobileInfo.stsId === STATUS_OK) {
            statusText = props.chequeStatusPaid;
        } else if (item.mobileInfo.stsId > STATUS_OK && (item.cancellingProcess || item.errorCode === 69)) {
            statusText = props.chequeStatusReverted;
        } else if (item.mobileInfo.stsId > STATUS_OK) {
            statusText = props.chequeStatusError;
        }
        return statusText;
    };

    return (
        <>
            <Row indent="adaptive-16-24">
                <ActivityIcon item={item} options={props.options} flagName={item?.toCountryISO?.toLowerCase()} />
            </Row>
            <ActivityTitle message={mobileInfo.title} color={textColor} />
            <Row indent="adaptive-24-32">
                <ActivityAmount options={props.options} item={item} baseColor="primary" />
                {item.payComment && (
                    <Text variant="paragraph" ellipsis color="secondary">
                        {item.payComment}
                    </Text>
                )}
            </Row>
            <Row indent={mobileInfo.errorMessage ? 'adaptive-16-24' : null}>
                <ActivityStatus isShowStatus status={mobileInfo.stsId} text={getStatusText()} />
            </Row>
            {mobileInfo.errorMessage && <div>{mobileInfo.errorMessage}</div>}

            <Separator marginTop="48px" marginBottom="48px" />
            <TableContainer>
                <TableRow title={props.chequeDate} textColor={textColor} titleColor={titleColor}>
                    {getGaActivityDate(item.payTs, props.lang)}
                </TableRow>
            </TableContainer>

            {(mobileInfo.extraFields?.Sender || mobileInfo.extraFields.Transfer || mobileInfo.extraFields.Bank) && (
                <>
                    <Separator marginTop="48px" marginBottom="48px" />
                    <TableContainer>
                        {mobileInfo.extraFields?.Sender && (
                            <TableRow title={props.senderTitle} textColor={textColor} titleColor={titleColor}>
                                {mobileInfo.extraFields.Sender}
                            </TableRow>
                        )}
                        {mobileInfo.extraFields?.Transfer && (
                            <TableRow title={props.transferTitle} textColor={textColor} titleColor={titleColor}>
                                {mobileInfo.extraFields.Transfer}
                            </TableRow>
                        )}
                        {mobileInfo.extraFields?.Bank && (
                            <TableRow title={props.chequeBlockBankHeader} textColor={textColor} titleColor={titleColor}>
                                {mobileInfo.extraFields.Bank}
                            </TableRow>
                        )}
                    </TableContainer>
                </>
            )}

            <Separator marginTop="48px" marginBottom="48px" />
            <TableContainer>
                <TableRow title={props.chequeFromCardHeader} textColor={textColor} titleColor={titleColor}>
                    {props.toLabel + ' ' + mobileInfo.toCurIso + ' ' + props.transferToAccount.toLowerCase()}
                </TableRow>
            </TableContainer>
        </>
    );
};

const mapStateToProps = (state) => ({
    transferTitle: state.messages.pageMessages.transferTitle,
    senderTitle: state.messages.pageMessages.senderTitle,
    toLabel: state.messages.pageMessages.toLabel,
    transferToAccount: state.messages.pageMessages.transferToAccount,
    chequeStatusInProgress: state.messages.pageMessages.chequeStatusInProgress,
    chequeAccountStatusInProgress: state.messages.pageMessages.chequeAccountStatusInProgress,
    chequeStatusWaitingVerification: state.messages.pageMessages.chequeStatusWaitingVerification,
    chequeStatusPaid: state.messages.pageMessages.chequeStatusPaid,
    chequeStatusReverted: state.messages.pageMessages.chequeStatusReverted,
    chequeStatusError: state.messages.pageMessages.chequeStatusError,
    chequeDate: state.messages.pageMessages.chequeDate,
    chequeFromCardHeader: state.messages.pageMessages.chequeFromCardHeader,
    chequeBlockBankHeader: state.messages.pageMessages.chequeBlockBankHeader,
    lang: state.language.lang,
});

export default connect(mapStateToProps)(ActivityFasterPaymentDetails);
